import React from 'react';
import { FaShoppingCart, FaFileAlt } from 'react-icons/fa';

const PurchaseCartIcon = ({ className = 'w-6 h-6', ...props }) => (
  <span className={`relative inline-flex ${className}`} {...props}>
    <FaShoppingCart className="w-full h-full text-current" />
    <FaFileAlt className="absolute right-0 bottom-0 w-3 h-3 text-white bg-[#5C1F33] rounded-full p-0.5" />
  </span>
);

export default PurchaseCartIcon;
